import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { CartDrawer } from "@/components/site/CartDrawer";
import HomePage from "@/pages/HomePage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import LookbookPage from "@/pages/LookbookPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/gb/en/home.html" replace />} />
            <Route path="/gb/en/home.html" element={<HomePage />} />
            <Route path="/gb/en/lookbook.html" element={<LookbookPage />} />
            <Route path="/gb/en/product/:id" element={<ProductDetailPage />} />
            <Route path="/gb/en/admin.html" element={<AdminPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="*" element={<Navigate to="/gb/en/home.html" replace />} />
          </Routes>
          <CartDrawer />
        </BrowserRouter>
      </CartProvider>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
